/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EvalDimRating } from './evalDimRating';

export type FlatTaskEvaluationOutputDimensions = { [key: string]: EvalDimRating };
